import {
  AI_RECOMPOSE_MODE,
  type AiRecomposeMode,
  GENERATION_INSTRUCTION_TYPE,
  type GenerationInstructionType,
} from 'src/data/generation/const';

export const BLOG_GUIDANCE_TYPE = {
  shorten: 'shorten',
  expand: 'expand',
  strict: 'strict',
  creative: 'creative',
  continueWriting: 'continueWriting',
  addExplanation: 'addExplanation',
  addExample: 'addExample',
  addList: 'addList',
  addConclusion: 'addConclusion',
  manualRewrite: 'manualRewrite',
} as const;
export type BlogGuidanceType = (typeof BLOG_GUIDANCE_TYPE)[keyof typeof BLOG_GUIDANCE_TYPE];

// TODO: do we really need these two types combined? can `blogGuidanceTypeToGenerationGuidanceType` return something else?
type InstructionTypeOrRecomposeMode = GenerationInstructionType | AiRecomposeMode;

const BLOG_GUIDANCE_TYPE_TO_GENERATION_GUIDANCE_TYPE: Record<
  string,
  InstructionTypeOrRecomposeMode
> = {
  [BLOG_GUIDANCE_TYPE.addExplanation]: GENERATION_INSTRUCTION_TYPE.explain,
  [BLOG_GUIDANCE_TYPE.addExample]: GENERATION_INSTRUCTION_TYPE.example,
  [BLOG_GUIDANCE_TYPE.addList]: GENERATION_INSTRUCTION_TYPE.list,
  [BLOG_GUIDANCE_TYPE.addConclusion]: GENERATION_INSTRUCTION_TYPE.conclusion,

  [BLOG_GUIDANCE_TYPE.shorten]: AI_RECOMPOSE_MODE.shorten, //need to add this to AI_RECOMPOSE_MODE
  [BLOG_GUIDANCE_TYPE.expand]: AI_RECOMPOSE_MODE.expand,
  [BLOG_GUIDANCE_TYPE.strict]: AI_RECOMPOSE_MODE.strict, // need to see what AC needs
  [BLOG_GUIDANCE_TYPE.creative]: AI_RECOMPOSE_MODE.refine, // need to see what AC needs
  [BLOG_GUIDANCE_TYPE.manualRewrite]: AI_RECOMPOSE_MODE.instructionBased,
};
export const blogGuidanceTypeToGenerationGuidanceType = (
  blogGuidanceType: BlogGuidanceType
): InstructionTypeOrRecomposeMode =>
  BLOG_GUIDANCE_TYPE_TO_GENERATION_GUIDANCE_TYPE[blogGuidanceType];
